/** How many genres each half of the line names, at most. */
const MAX_FAVOURITES = 3;
const MAX_AVOIDED = 2;
/**
 * Below this many votes the line says nothing: three swipes in, "your group
 * loves westerns" is one person's first card, not a taste.
 */
export const MIN_TASTE_VOTES = 6;
/**
 * Sums every vote into the genres of the film it was cast on.
 *
 * Net rather than likes alone: a genre with ten yeses and ten noes is a
 * genre the group argues about, not one it leans towards. A film with two
 * genres counts towards both — a sci-fi comedy the room loved says something
 * about each. Ties go to the genre with more yeses behind it, then to the
 * genre id, so the line does not reshuffle between two identical reads.
 */
export function groupTaste(results) {
    let votes = 0;
    const genres = new Map();
    for (const entry of results) {
        votes += entry.likes + entry.neutrals + entry.dislikes;
        for (const genre of entry.movie.genres) {
            const current = genres.get(genre) ?? { net: 0, likes: 0, dislikes: 0 };
            current.net += entry.likes - entry.dislikes;
            current.likes += entry.likes;
            current.dislikes += entry.dislikes;
            genres.set(genre, current);
        }
    }
    if (votes < MIN_TASTE_VOTES)
        return null;
    const ranked = [...genres.entries()];
    const favourites = ranked
        .filter(([, tally]) => tally.net > 0)
        .sort(([a, x], [b, y]) => y.net - x.net || y.likes - x.likes || a.localeCompare(b))
        .slice(0, MAX_FAVOURITES)
        .map(([genre]) => genre);
    const avoided = ranked
        .filter(([, tally]) => tally.net < 0)
        .sort(([a, x], [b, y]) => x.net - y.net || y.dislikes - x.dislikes || a.localeCompare(b))
        .slice(0, MAX_AVOIDED)
        .map(([genre]) => genre);
    if (favourites.length === 0 && avoided.length === 0)
        return null;
    return { favourites, avoided };
}
